import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";

import ModalApproveSfa from "./sfaComponents/ModalApproveSfa";
import { getDetailSfa } from "../../../services/sfaApi";
import { CircularProgress } from "@mui/material";
import { ImInsertTemplate } from "react-icons/im";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const SfaDetail = () => {
  const { id } = useParams();

  const [openActionModal, setOpenActionModal] = useState(false);
  const [action, setAction] = useState(null);

  const {
    data: dataDetail,
    isFetching: isFetchingDetail,
    refetch: refetchDetail,
  } = useQuery({
    queryKey: ["detail-sfa", id],
    queryFn: () => getDetailSfa(id),
    refetchOnWindowFocus: false,
  });

  return (
    <div className="text-[12px]">
      <div className="lg:flex gap-2 items-start mb-4">
        <div className="w-full">
          <div className="flex gap-2 items-center w-full mb-4">
            <div className="w-full">
              <p className="font-semibold">Tanggal Order</p>
              {dataDetail && !isFetchingDetail ? (
                <p>{moment(dataDetail.order_date).format("DD MMMM YYYY")}</p>
              ) : isFetchingDetail ? (
                <CircularProgress size={10} />
              ) : (
                "-"
              )}
            </div>
            <div className="w-full">
              <p className="font-semibold">Jam Order</p>
              {dataDetail && !isFetchingDetail ? (
                <p>{dataDetail.order_time}</p>
              ) : isFetchingDetail ? (
                <CircularProgress size={10} />
              ) : (
                "-"
              )}
            </div>
          </div>
          <div className="flex gap-2 items-center w-full mb-4">
            <div className="w-full">
              <p className="font-semibold">Order ID</p>
              {dataDetail && !isFetchingDetail ? (
                <p>{dataDetail.order_number}</p>
              ) : isFetchingDetail ? (
                <CircularProgress size={10} />
              ) : (
                "-"
              )}
            </div>
            <div className="w-full">
              <p className="font-semibold">No SP/PO</p>
              {dataDetail && !isFetchingDetail ? (
                <p>{dataDetail.po_number}</p>
              ) : isFetchingDetail ? (
                <CircularProgress size={10} />
              ) : (
                "-"
              )}
            </div>
          </div>
          <div className="flex gap-2 items-center w-full mb-4">
            <div className="w-full">
              <p className="font-semibold">Sumber PO</p>
              {dataDetail && !isFetchingDetail ? (
                <p>
                  {dataDetail.po_source !== "OLIN" ? "Salesman" : ""}{" "}
                  {dataDetail.po_source}
                </p>
              ) : isFetchingDetail ? (
                <CircularProgress size={10} />
              ) : (
                "-"
              )}
            </div>
            {dataDetail &&
            (dataDetail.status === 1 || dataDetail.status === 2) ? (
              <div className="w-full">
                <p className="font-semibold">Status</p>
                {dataDetail && !isFetchingDetail ? (
                  <p
                    className={`${
                      dataDetail.status === 1
                        ? "text-green-500"
                        : "text-red-500"
                    }`}
                  >
                    {dataDetail.status === 1 ? "Diterima" : "Ditolak"}
                  </p>
                ) : isFetchingDetail ? (
                  <CircularProgress size={10} />
                ) : (
                  "-"
                )}
              </div>
            ) : null}
          </div>
        </div>
        {dataDetail && dataDetail.status === 0 ? (
          <div className="lg:basis-2/3 flex gap-2 items-center w-full">
            <button
              className="w-full border-2 rounded-md p-2 border-red-500 text-red-500 hover:bg-red-100 disabled:bg-gray-300 disabled:border-none disabled:text-white"
              // disabled={!isValidChange(true)}
              onClick={() => {
                setAction(2);
                setOpenActionModal(true);
              }}
            >
              Tolak
            </button>
            <button
              className="w-full border-2 rounded-md p-2 border-blue-500 bg-blue-500 text-white hover:bg-gray-300 disabled:bg-gray-300 disabled:border-gray-300"
              // disabled={!isValidChange(false)}
              onClick={() => {
                setAction(1);
                setOpenActionModal(true);
              }}
            >
              Terima
            </button>
          </div>
        ) : null}
      </div>

      <div className="mb-4">
        <p className="text-[14px] font-semibold border-b-2 pb-2">
          Informasi Produk
        </p>
        <div>
          {dataDetail && !isFetchingDetail ? (
            dataDetail.products.map((item, i) => (
              <div
                key={i}
                className="border-b-2 flex items-center justify-between gap-8 py-2"
              >
                <div>
                  <p className="mb-2 text-[14px]">{item.product_name}</p>
                  <p>
                    {item.quantity} x {toIDR(item.price)}
                  </p>
                </div>
                <p className="font-semibold text-[14px]">{toIDR(item.total)}</p>
              </div>
            ))
          ) : isFetchingDetail ? (
            <CircularProgress size={20} sx={{ marginTop: 2 }} />
          ) : null}
        </div>
      </div>

      <p className="text-[14px] font-semibold mb-2">Rincian Pembayaran</p>
      {dataDetail && !isFetchingDetail ? (
        <div>
          <div className="flex justify-between items-center font-semibold">
            <p>Produk</p>
            <p>Subtotal</p>
          </div>
          <hr className="my-2" />
          <div className="flex justify-between items-center mb-2">
            <p>Metode Pembayaran</p>
            <p>{dataDetail.payment_method}</p>
          </div>
          <div className="flex justify-between items-center mb-2">
            <p>Total harga ( {dataDetail.products?.length} produk)</p>
            <p>{toIDR(dataDetail.total_price)}</p>
          </div>
          <div className="flex justify-between items-center mb-2">
            <p>Biaya pengiriman</p>
            <p>
              {dataDetail.delivery_fee > 0
                ? toIDR(dataDetail.delivery_fee)
                : "Gratis"}
            </p>
          </div>
          <div className="flex justify-between items-center mb-2">
            <p>Pajak (PPN 11%)</p>
            <p>{toIDR(dataDetail.ppn)}</p>
          </div>
          <div className="flex justify-between items-center mb-2">
            <p>Biaya admin</p>
            <p>{toIDR(dataDetail.admin_fee)}</p>
          </div>
          {dataDetail.total_discount > 0 ? (
            <div className="flex justify-between items-center mb-2">
              <p>Promo</p>
              <p>-{toIDR(dataDetail.total_discount)}</p>
            </div>
          ) : null}
          {dataDetail.olin_point > 0 ? (
            <div className="p-2 rounded-md bg-yellow-100 text-amber-500 flex justify-between items-center mb-2">
            <div>
              <p className="font-semibold">Olin Point</p>
              <p>Dari transaksi pembelian</p>
            </div>
            <p>{toIDR(dataDetail.olin_point)}</p>
          </div>
          ) : null}
          <hr className="mb-2" />
          <div className="flex justify-between items-center mb-4 font-semibold">
            <p>Total</p>
            <p>{toIDR(dataDetail.total)}</p>
          </div>
        </div>
      ) : isFetchingDetail ? (
        <CircularProgress size={20} sx={{ marginTop: 2 }} />
      ) : null}

      {dataDetail && action ? (
        <ModalApproveSfa
          open={openActionModal && action}
          setOpen={setOpenActionModal}
          selectedRequest={{ invNum: dataDetail.order_number, action: action }}
          onSuccessFunc={() => {
            setAction(null);
            refetchDetail();
          }}
        />
      ) : null}
    </div>
  );
};

export default SfaDetail;
